import { graphql } from '@search/gql-client/src/useGql';

export const query = graphql`
    query NewBuildingConstructionQuery(
        $id: Int!
        $whiteLabel: NewBuildingWhitelabelEnum
        $skipFavorites: Boolean!
    ) {
        newBuilding(
            id: $id
            whiteLabel: $whiteLabel
        ) {
            id
            narrowRegionId(whiteLabel: $whiteLabel)
            narrowRegionLocative(whiteLabel: $whiteLabel)
            backofficeRegionId
            hasApartments
            hasApartmentsOnly
            isSoldOut
            isSoon
            hasMilitaryMortgage
            ranking
            hasChat(whiteLabel: $whiteLabel)
            title {
                genitive
                locative
                accusative
                nominative
                dative
            }
            type
            name
            seo(whiteLabel: $whiteLabel) {
                seoTitle
            }
            priceMin
            priceMax
            pricePerM2Min
            pricePerM2Max
            formatAreaRange
            mortgageMinPay {
                term
                rate
                creditAmount
                minPay
                variant
                initialFee
            }
            buildingClass {
                value
                label
                fullLabel
            }
            buildingStatus {
                title
                isFrozen
            }
            isMskMO
            isSPbLO
            isSpecProjectRegion
            coordinates
            polygons
            address
            description
            fullDescription {
                html
            }
            routes(type: [ METRO ]) {
                ...on RouteMetro {
                    station {
                        id
                        name
                        lines
                    }
                    timeMinutes
                    transportType
                }
            }
            description
            position
            developerCards {
                developer {
                    id
                    isSamolet
                    title
                    translitTitle
                    webSite
                    icon {
                        origin
                    }
                    phones {
                        formattedNumber
                    }
                    image {
                        small
                    }
                }
                commissionedCount {
                    value
                    shortLabel
                }
                inProgressCount {
                    value
                    shortLabel
                }
            }
            gallery {
                baseUrl
            }
            constructionProgress {
                image {
                    galleryPhoto
                    medium
                    mediumMobile
                    galleryThumbnail
                    originPath
                }
                year
                quarter
                address
            }
            mortgageParams {
                regionId
                isMainRegion
                propertyCost
                purpose
                purposeValue
                claimType
                ownAmount
                term
                purposeValue
                claimType
            }
            routeParams {
                region
                regionId
                subRegion
                name
                type
                id
            }
            isFavorite @skip(if: $skipFavorites)
            infoList
            advantagesList
            conditions {
                image {
                    small
                }
                description
            }
            simplifiedCardHeader
            buildingStats {
                text
            }
            m2Pro {
                prepayment
                cooperationTerms {
                    title
                    fileName
                    url
                }
                nbPresentation {
                    title
                    fileName
                    url
                }
            }
        }
    }
`;
